import ArrowLeft from "../../UI/atoms/arrowLeft";
import ArrowRight from "../../UI/atoms/arrowRight";

export const settings = {
  dots: true,
  infinite: false,
  arrows: true,
  prevArrow: (
    <div className="arrow-left">
      <ArrowLeft />
    </div>
  ),
  nextArrow: (
    <div className="arrow-left">
      <ArrowRight />
    </div>
  ),
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
